import { render, staticRenderFns } from "./GiveFeedbackSuccessIcon.vue?vue&type=template&id=65fa0c00&"
import script from "./GiveFeedbackSuccessIcon.vue?vue&type=script&lang=js&"
export * from "./GiveFeedbackSuccessIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports